import React, { Component } from 'react';
import { initialize } from 'redux-form';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { reset } from 'redux-form';
import { loadSentEmails } from './actions';
import List from './List';
import Filter from './Filter';
import Dialog from '../../../common/components/Dialog';

class SentEmailsReport extends Component {
	constructor(props) {
		super(props);
		this.handleFilterSubmit = this.handleFilterSubmit.bind(this);
		this.handleListEvent = this.handleListEvent.bind(this);
		this.handleShowMessageText = this.handleShowMessageText.bind(this);

		this.state = {
			showMessageText: false
		};
	}

	componentDidMount() {
		const { sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;

		let filter;
		if (this.props.parentId > 0) {
			filter = { parentId: this.props.parentId };
		} else if (this.props.subscriptionContractId > 0) {
			// the notices about one subscription
			filter = { externalId: this.props.subscriptionContractId, externalIdType: 'SubscriptionContract' };
		} else {
			filter = { ...(this.props.pagination.filter || {}), parentId: null };
		}

		this.loadData({ filter, sortKey, sortDirection, pageNumber, pageSize });
		this.props.initializeFilter(filter);
	}

	loadData({ filter, sortKey, sortDirection, pageNumber, pageSize }) {
		this.props.loadEntities({ ...filter, sortKey, sortDirection, pageSize, pageNumber }, this.props.listKey);
	}

	handleFilterSubmit(filter) {
		const { sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;
		this.loadData({ filter, sortKey, sortDirection, pageNumber: 1, pageSize });
	}

	handleListEvent(listPagination) {
		const { filter } = this.props.pagination;
		this.loadData({ filter, ...listPagination });
	}

	handleShowMessageText(message) {
		if (this.props.onShowMessage) {
			this.props.onShowMessage(message);
			return;
		}
		this.setState({ showMessageText: true, messageText: message })
	}

	render() {
		const { t, parentId, subscriptionContractId } = this.props;
		const { filter } = this.props.pagination;
		const messageTextDialogConfig = {
			header: t('ParentCommunication_Message'),
			body: <span dangerouslySetInnerHTML={{ __html: this.state.messageText }} />,
			onHide: () => this.setState({ showMessageText: false })
		};
		return (
			<div>
				{!parentId && !subscriptionContractId && <Filter onSubmit={this.handleFilterSubmit} initialValues={filter} loading={this.props.pagination.loading} />}
				<List parentId={parentId} hideParent={!!subscriptionContractId} embedded={this.props.embedded} data={this.props.data} onFetchData={this.handleListEvent} onShowMessage={(message) => this.handleShowMessageText(message)} {...this.props.pagination} />
				{!this.props.onShowMessage && <Dialog config={messageTextDialogConfig} show={this.state.showMessageText} t={t} bsSize='large' />}
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	const { parentId, subscriptionContractId } = ownProps;
	const {
		pagination,
		entities: { sentEmails }
	} = state;

	const listKey = subscriptionContractId ? `subscription-${subscriptionContractId}` : null;
	const sentEmailsPagination = (listKey ? pagination.sentEmails[listKey] : parentId ? pagination.sentEmails[`parent-${parentId}`] : pagination.sentEmails.all) || { ids: [], pageNumber: 1, pageSize: 10 };

	return {
		parentId,
		listKey,
		data: sentEmailsPagination.ids.map(id => sentEmails[id]),
		pagination: sentEmailsPagination
	};
};

export default connect(mapStateToProps, {
	loadEntities: loadSentEmails,
	resetFilter: () => reset('sentEmailsFilter'),
	initializeFilter: (data, fields) => initialize('sentEmailsFilter', data, fields)
})(withTranslation()(SentEmailsReport));